<template>
  <div
    role="menubar"
    class="flex items-center bg-gray-50 border border-gray-200 rounded-t overflow-hidden"
  >
    <button
      v-for="item in items"
      role="menuitem"
      :key="item.label"
      :disabled="!item.available"
      @click.prevent="emit('click', item)"
      class="cursor-pointer px-3.5 py-4 border-r last:-mr-px text-sm font-mono h-7 min-w-7 flex items-center justify-center disabled:text-gray-400 disabled:cursor-not-allowed disabled:bg-gradient-to-b disabled:from-transparent disabled:to-gray-200/50 transition"
      :class="{
        'font-medium bg-white hover:bg-gray-100 hover:text-blue-700 focus:-outline-offset-4 focus:outline-blue-500 focus:bg-gray-100 text-gray-700':
          !item.active && item.available,
        'bg-gradient-to-b from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-100 text-blue-800 hover:text-blue-700 font-bold':
          item.active,
      }"
      type="button"
      :aria-disabled="!item.available"
      :aria-label="item.ariaLabel || item.label"
      :aria-description="item.ariaDescription"
    >
      <s-icon v-if="item.icon" :name="item.icon" size="15" />
      <span v-else>
        {{ item.label }}
      </span>
    </button>
  </div>
</template>
<script setup lang="ts">
import {MenuViewItem} from '../views/MenuView';
import SBtn from '../../../design-system/SBtn.vue';
import SIcon from '../../../design-system/SIcon.vue';

defineProps<{
  items: MenuViewItem[];
}>();

const emit = defineEmits<{
  click: [item: MenuViewItem];
}>();
</script>
